export class EvaCompanyExpenseReportConfig {
  public manager_ids = [];
}
